import { Button } from '@/components/ui/button';
import { LogOut, Loader2 } from 'lucide-react';
import { useProxy } from '@/contexts/ProxyContext';

interface ProxyExitButtonProps {
  variant?: 'default' | 'ghost' | 'outline';
  size?: 'sm' | 'default';
  className?: string;
}

export function ProxyExitButton({ 
  variant = 'ghost', 
  size = 'sm', 
  className 
}: ProxyExitButtonProps) {
  const { isProxyMode, endProxySession, isEnding } = useProxy();

  // Only show if in proxy mode
  if (!isProxyMode) {
    return null;
  }

  return (
    <Button
      variant={variant}
      size={size}
      onClick={endProxySession}
      disabled={isEnding}
      className={`text-warning hover:text-warning/90 hover:bg-warning/10 ${className}`}
      aria-label="Exit proxy session and return to your account"
    >
      {isEnding ? (
        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
      ) : (
        <LogOut className="h-4 w-4 mr-2" />
      )}
      {isEnding ? 'Exiting...' : 'Exit Proxy'}
    </Button>
  );
}